export function compareHeight(a, b) {
  return a.value - b.value;
}
